// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escalation {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  background: #f5f7fa;
  color: #333;
  overflow-y: hidden;
  letter-spacing: normal;
}

.escalation .page-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.escalation .card {
  background: var(--color-white);
  border-radius: 6px;
  padding: 0px !important;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.escalation .card-header{
  border-bottom: 2px solid var(--color-primary-orange);
  font-size: 1rem;
  font-weight: 600;
  
} 

.escalation .card-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}

.escalation .form-label {
  color: #495057;
  font-weight: 500;
  margin-bottom: 8px;
}


/* action section css start */

.escalation .actions-section {
  font-family: "Segoe UI", sans-serif;
}

/* Make sure both sides (left & right dropdown/input) stay aligned */
.escalation .action-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.escalation .action-number {
  width: 26px;
  height: 26px;
  background-color: #16a34a;
  color: var(--color-white);
  font-weight: 600;
  font-size: 0.8rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.escalation .action-field .dropdown-select,
.escalation .action-value .dropdown-select,
.escalation .action-input {
  width: 100% !important;
  height: 38px !important;
  font-size: 0.9rem;
  border-radius: 6px;
}

/* Ensure all dropdowns and inputs look identical in width and height */
.escalation .action-field,
.escalation .action-value {
  flex: 1 1;
  min-width: 260px; /* gives consistent base width */
}
.escalation .cursor-pointer {
  cursor: pointer;
}

/* Prevent Bootstrap from shrinking smaller dropdowns */
.escalation .action-row .flex-grow-1 {
  flex-grow: 1 !important;
  flex-basis: 0 !important;
}

/* For consistent spacing on "Edit" and "Delete" */
.escalation .action-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
}
.escalation .action-icon {
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.escalation .actions-section select,
.escalation .actions-section input,
.escalation .actions-section .form-control {
  height: 36px !important;
  border-radius: 8px !important;
  font-size: 0.9rem;
}

.escalation .actions-section .Dropdown-root {
  width: 548px !important;
}
.escalation .actions-section .text-danger.small {
  font-size: 0.85rem;
  margin-left: 3rem; 
}
/* action section css end */


/* condition section css start */
/* small helpers for the group colors */
.escalation .border-purple { border-color: #9c27b0 !important; }
.escalation .text-purple   { color: #9c27b0 !important; }
.escalation .bg-purple     { background-color: #9c27b0 !important; }
 
.escalation .border-orange { border-color: var(--color-primary-orange) !important; }
.escalation .text-orange   { color: var(--color-primary-orange) !important; }
.escalation .bg-orange     { background-color: var(--color-primary-orange) !important; }
 
/* group badge style */
.escalation .group-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
 
/* connector pill shown in summary (non-editable) */
.escalation .connector-pill {
  display: inline-block;
  margin-left: 8px;
  margin-right: 8px;
  background: #fff8e1;
  border: 2px solid #ffc107;
  color: #111;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}
 
/* connector dropdown centered between group cards */
.escalation .connector-container { display:flex; justify-content:center; }
.escalation .logic-dropdown {
  border: 2px solid #ffc107 !important;
  border-radius: 20px !important;
  padding: 2px 12px !important;
  width: 90px;
  font-weight: 600;
  background-color: #fff8e1 !important;
  text-align: center;
}
 
/* small active conditions box visuals */
.escalation .active-conditions .badge { font-size: 12px; }
.escalation .active-conditions { display:flex; align-items:center; flex-wrap:wrap; gap: 8px; }
 
/* responsive spacing */
@media (max-width: 768px) {
  .escalation .condition-group .row > * { margin-bottom: 8px; }
  .escalation .logic-dropdown { width: 70px; padding: 2px 8px; }
}

/* condition section css end */

/*  Rule configue css start  */

  .escalation .form-textarea-field .col-2,
  .escalation .form-textarea-field .col-10 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

/*  Rule configue css end  */`, "",{"version":3,"sources":["webpack://./src/containers/vision_hub/escalation_rule_builder/EscalationRuleBuilder.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;EACpD,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA,6BAA6B;;AAE7B;EACE,mCAAmC;AACrC;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;;EAEE,SAAO;EACP,gBAAgB,EAAE,gCAAgC;AACpD;AACA;EACE,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA,2BAA2B;;;AAG3B,gCAAgC;AAChC,uCAAuC;AACvC,6BAA6B,gCAAgC,EAAE;AAC/D,6BAA6B,yBAAyB,EAAE;AACxD,6BAA6B,oCAAoC,EAAE;;AAEnE,6BAA6B,oDAAoD,EAAE;AACnF,6BAA6B,6CAA6C,EAAE;AAC5E,6BAA6B,wDAAwD,EAAE;;AAEvF,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD,mCAAmC,YAAY,EAAE,sBAAsB,EAAE;AACzE;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC,wCAAwC,eAAe,EAAE;AACzD,iCAAiC,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,QAAQ,EAAE;;AAE7F,uBAAuB;AACvB;EACE,wCAAwC,kBAAkB,EAAE;EAC5D,8BAA8B,WAAW,EAAE,gBAAgB,EAAE;AAC/D;;AAEA,8BAA8B;;AAE9B,8BAA8B;;EAE5B;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;AAEF,4BAA4B","sourcesContent":[".escalation {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 14px;\n  background: #f5f7fa;\n  color: #333;\n  overflow-y: hidden;\n  letter-spacing: normal;\n}\n\n.escalation .page-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.escalation .card {\n  background: var(--color-white);\n  border-radius: 6px;\n  padding: 0px !important;\n  margin-bottom: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.escalation .card-header{\n  border-bottom: 2px solid var(--color-primary-orange);\n  font-size: 1rem;\n  font-weight: 600;\n  \n} \n\n.escalation .card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.escalation .form-label {\n  color: #495057;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n\n/* action section css start */\n\n.escalation .actions-section {\n  font-family: \"Segoe UI\", sans-serif;\n}\n\n/* Make sure both sides (left & right dropdown/input) stay aligned */\n.escalation .action-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.escalation .action-number {\n  width: 26px;\n  height: 26px;\n  background-color: #16a34a;\n  color: var(--color-white);\n  font-weight: 600;\n  font-size: 0.8rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.escalation .action-field .dropdown-select,\n.escalation .action-value .dropdown-select,\n.escalation .action-input {\n  width: 100% !important;\n  height: 38px !important;\n  font-size: 0.9rem;\n  border-radius: 6px;\n}\n\n/* Ensure all dropdowns and inputs look identical in width and height */\n.escalation .action-field,\n.escalation .action-value {\n  flex: 1;\n  min-width: 260px; /* gives consistent base width */\n}\n.escalation .cursor-pointer {\n  cursor: pointer;\n}\n\n/* Prevent Bootstrap from shrinking smaller dropdowns */\n.escalation .action-row .flex-grow-1 {\n  flex-grow: 1 !important;\n  flex-basis: 0 !important;\n}\n\n/* For consistent spacing on \"Edit\" and \"Delete\" */\n.escalation .action-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  white-space: nowrap;\n}\n.escalation .action-icon {\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.escalation .actions-section select,\n.escalation .actions-section input,\n.escalation .actions-section .form-control {\n  height: 36px !important;\n  border-radius: 8px !important;\n  font-size: 0.9rem;\n}\n\n.escalation .actions-section .Dropdown-root {\n  width: 548px !important;\n}\n.escalation .actions-section .text-danger.small {\n  font-size: 0.85rem;\n  margin-left: 3rem; \n}\n/* action section css end */\n\n\n/* condition section css start */\n/* small helpers for the group colors */\n.escalation .border-purple { border-color: #9c27b0 !important; }\n.escalation .text-purple   { color: #9c27b0 !important; }\n.escalation .bg-purple     { background-color: #9c27b0 !important; }\n \n.escalation .border-orange { border-color: var(--color-primary-orange) !important; }\n.escalation .text-orange   { color: var(--color-primary-orange) !important; }\n.escalation .bg-orange     { background-color: var(--color-primary-orange) !important; }\n \n/* group badge style */\n.escalation .group-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n \n/* connector pill shown in summary (non-editable) */\n.escalation .connector-pill {\n  display: inline-block;\n  margin-left: 8px;\n  margin-right: 8px;\n  background: #fff8e1;\n  border: 2px solid #ffc107;\n  color: #111;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-weight: 600;\n}\n \n/* connector dropdown centered between group cards */\n.escalation .connector-container { display:flex; justify-content:center; }\n.escalation .logic-dropdown {\n  border: 2px solid #ffc107 !important;\n  border-radius: 20px !important;\n  padding: 2px 12px !important;\n  width: 90px;\n  font-weight: 600;\n  background-color: #fff8e1 !important;\n  text-align: center;\n}\n \n/* small active conditions box visuals */\n.escalation .active-conditions .badge { font-size: 12px; }\n.escalation .active-conditions { display:flex; align-items:center; flex-wrap:wrap; gap: 8px; }\n \n/* responsive spacing */\n@media (max-width: 768px) {\n  .escalation .condition-group .row > * { margin-bottom: 8px; }\n  .escalation .logic-dropdown { width: 70px; padding: 2px 8px; }\n}\n\n/* condition section css end */\n\n/*  Rule configue css start  */\n\n  .escalation .form-textarea-field .col-2,\n  .escalation .form-textarea-field .col-10 {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n  }\n\n/*  Rule configue css end  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
